var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.categoryLoaded
    ? _c(
        "div",
        [
          _c("h3", { staticClass: "category-title" }, [
            _vm._v(_vm._s(_vm.category.name))
          ]),
          _vm._v(" "),
          _vm._l(_vm.questions, function(ref) {
            var id = ref.id
            var type = ref.type
            var name = ref.name
            return [
              _c("div", { key: id, staticClass: "question-container" }, [
                _c("label", { staticClass: "question-name" }, [
                  _vm._v("\n                " + _vm._s(name) + "\n            ")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "question-content" },
                  [
                    _c(type, {
                      key: id,
                      tag: "component",
                      attrs: { "question-id": id }
                    })
                  ],
                  1
                )
              ])
            ]
          })
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }